import { FooterNavigationItem } from '@/config/nav/footer-navigation';
import { cn } from '@/lib/utils';
import Link from 'next/link';

interface FooterColumnProps {
  title: string;
  items: FooterNavigationItem[];
  className?: string;
}

export function FooterColumn({ title, items, className }: FooterColumnProps) {
  return (
    <div className={cn("flex flex-col", className)}>
      {/* Anton uppercase column heading on the dark chrome, per the
          design-system footer spec: letter-spacing .08em, chrome-fg
          foreground. */}
      <h3 className="text-sm uppercase tracking-[.08em] text-[color:var(--cw-chrome-fg)]">
        {title}
      </h3>
      <ul role="list" className="mt-6 space-y-4">
        {items.map((item) => {
          // The one emphasised link per column set ("All Fleet Categories →")
          // renders in sun, not teal: the brand teal on this surface is
          // 3.80:1, under the AA target at this size (design-system footer
          // spec). Sun on the same surface is 7.87:1. Both measured against
          // the ink chrome the footer moved to on 2026-09-09; on the plum it
          // replaced, teal was 4.46:1, still short.
          const isEmphasised = item.name.endsWith('→');
          return (
            <li key={item.name}>
              <Link
                href={item.href}
                className={cn(
                  'text-sm transition-opacity hover:opacity-70',
                  isEmphasised
                    ? 'font-semibold text-[color:var(--cw-sun)]'
                    : 'text-[color:var(--cw-chrome-fg)]/70'
                )}
              >
                {item.name}
                {item.badge && (
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs bg-[color:var(--cw-lime)] text-[color:var(--cw-ink)] ml-2">
                    {item.badge}
                  </span>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
